var email = window.customerDetails?.email;
if (email === "") {
    email = undefined;
}
(function (d, s, id, cb) {
    var js = d.createElement(s);
    var n = d.createElement("div");
    n.id = id;
    if (js.readyState) {
        js.onreadystatechange = function () { if (js.readyState === "loaded" || js.readyState === "complete") { js.onreadystatechange = null; cb(); } };
    } else { js.onload = function () { cb(); }; }
    js.src = "https://woxer.chat.getzowie.com/web/live-chat/chatbotize-entrypoint.min.js";
    document.body.appendChild(js);
    document.body.appendChild(n);
})(document, "script", "chatbotize", function () {
    Chatbotize.init({
        instanceId: "4c893f6e4ee94e02b06a992026dc53c4",
        startOnOpen: true,
        headerMode: "white",
        ecommerceShopifyTracking: true,
        ecommerceCartWatchEnabled: false,
        metadata: {
            email: email
        },
        onOpen: function () {
            if (window.innerWidth <= 470) {
                document.body.style.overflow = "hidden";
            }
        },
        onClose: function () {
            if (window.innerWidth <= 470) {
                document.body.style.overflow = null;
                document.documentElement.style.overflow = null;
                document.documentElement.style.position = null;
                document.documentElement.style.inset = null;
            }
        }
    });
});